/**
 * 个股行情盘口签
 */
import React from "react"
import { PageType, StockSubType } from "../../pagetype"
import "../index.less"
import { FundsFlow } from "./funds_flow"
import {MainHoldings} from "./main_holdings"
import { PanKouTradeDetail } from "./pankou_trade_detail"

export function StockPanKou(props:{data:any,quotecode:string,pagetype:PageType,stocksubtype:StockSubType}) {
  if(!props.data){
    return <></>
  }
  
  return (
    <div className='stock-infos-list'>
      <FundsFlow data={props.data}/>
      <MainHoldings data={props.data.f178}/>
      <PanKouTradeDetail data={props.data} quotecode={props.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype}/>
    </div>
  )
}
